module.exports = "/assets/side-events-hero-christmas.jpg?xzh0BWF";